module.exports = __webpack_public_path__ + "img/orcamento_logo.9513917c.svg";